
















import { Component, Vue, Model, Prop } from 'vue-property-decorator'

@Component({
    components: {
        buttonProfile: () => import('../../components/core/ButtonProfile.vue'),
    }
})
export default class Toolbar extends Vue {
    
    @Model('change', { type: Boolean }) showSideIcon!: boolean
    @Prop(String) title!: string

}
